<template>
    <div v-if="dataView.isLoaded">
        <div class="pageheader">          
            <h1>
                {{ this.dataView.forecast.title }}
            </h1>
            <p>{{ this.dataView.forecast.description }}</p>
        </div>
        <div class="page gc">
            <SideMenu />

            <template v-if="dataView.forecast.typeName === 'Study'">
                <template v-if="this.$route.params.section == 'demand'">
                    <Demand></Demand>
                </template>
                <template v-else-if="this.$route.params.section == 'materials'">
                    <Materials></Materials>
                </template>
                <template v-else-if="this.$route.params.section == 'distribution'">
                    <Distribution></Distribution>
                </template>
                <template v-else-if="this.$route.params.section == 'events'">
                    <Events></Events>
                </template>
            </template>
            <template v-else-if="dataView.forecast.typeName === 'Aggregation'">
                <template v-if="this.$route.params.section == 'demand'">
                    <AggregationDemand></AggregationDemand>
                </template>
                <template v-else-if="this.$route.params.section == 'materials'">
                    <AggregationMaterials></AggregationMaterials>
                </template>
            </template>
            <template v-if="this.$route.params.section == 'share'">
                <Share></Share>
            </template>

        </div>
    </div>
</template>

<script>
    import SideMenu from "../Components/SideMenuDataView.vue"
    import Demand from "../Components/DataView/Study/Demand.vue"
    import Materials from "../Components/DataView/Study/Materials.vue"
    import Distribution from "../Components/DataView/Study/Distribution.vue"
    import Events from "../Components/DataView/Study/Events.vue"
    import Share from "../Components/DataView/Share.vue"

    import AggregationDemand from "../Components/DataView/Aggregation/Demand.vue"
    import AggregationMaterials from "../Components/DataView/Aggregation/Materials.vue"

    import { mapState } from "vuex"

    export default {
        components: {
            SideMenu,
            Demand,
            Materials,
            Distribution,
            Events,
            Share,
            AggregationDemand,
            AggregationMaterials
        },
        computed: mapState([
            "dataView"
        ]),
        mounted() {
            // If stored id is the same, then keep values to save loadtimes.
            if(this.dataView.currentId == this.$route.params.id){
                return;
            }
            // Else, clear all stored dataView
            this.dataView.forecast = {};

            this.$store.dispatch("getDataViewForecast", this.$route.params.id).then((data) =>{
                document.title = data.data.title;
                this.dataView.forecast = data.data;
                this.dataView.isLoaded = true;
            });

            this.dataView.currentId = this.$route.params.id;
        },
        methods: {

        }
    }
</script>
